import React from "react";
import { Redirect } from "react-router-dom";
import { X_API_KEY } from "../../utils/authentication";

export default class Logout extends React.Component {
    constructor(props) {
        super(props);

        localStorage.removeItem(X_API_KEY);
        localStorage.removeItem("user");
    }

    getParameterByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return "";
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    render() {
        let brandParam = "";
        const brand = this.getParameterByName("brand");

        if (brand) {
            brandParam = `&brand=${brand}`;
        }

        return <Redirect to={`/login?force=1${brandParam}`} />;
    }
}
